var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCapitol(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    fill: "#ff5b5b",
    r: 256
  }))))))), /*#__PURE__*/React.createElement("path", {
    d: "m445.152 428.498c27.869-30.543 48.437-67.858 58.952-109.191l-248.621-248.621v68.616l-63.612 55.661-32.084 8.041 18.5 18.5.472 56.047-39.526 4.387 32.465 32.465-41.105.281-54.47 6.521 33.821 33.821-23.717 46.335 101.387 101.387c21.771 6.02 44.7 9.252 68.386 9.252 48.882 0 94.559-13.707 133.411-37.477z",
    fill: "#c73c50"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m86.236 312.84h74.069v88.471h-74.069z",
    fill: "#dbe1e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.122 304.477h84.182v16.728h-84.182z",
    fill: "#c7d1db"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m263.847 124.071h-16.728v-7.903l8.364-45.482 8.364 45.482z",
    fill: "#c7d1db"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m170.147 197.977h170.671v78.385h-170.671z",
    fill: "#f7f9fa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m149.943 273.574h211.08v127.738h-211.08z",
    fill: "#f7f9fa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m326.855 186.287h-142.744c0-39.417 31.954-71.372 71.372-71.372s71.372 31.954 71.372 71.372z",
    fill: "#f7f9fa"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m351.696 312.84h74.069v88.471h-74.069z",
    fill: "#c7d1db",
    transform: "matrix(-1 0 0 -1 777.46 714.152)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m351.696 304.477h84.182v16.728h-84.182z",
    fill: "#a1aab7",
    transform: "matrix(-1 0 0 -1 787.573 625.681)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#dbe1e8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m255.483 197.977h85.336v78.385h-85.336z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255.483 273.574h105.54v127.738h-105.54z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m326.855 186.287h-71.372v-71.372c39.417 0 71.372 31.954 71.372 71.372z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m159.787 186.277h191.391v16.728h-191.391z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m139.233 265.21h232.501v16.728h-232.501z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m166.083 334.587h84.864v16.728h-84.864z",
    fill: "#5a5f64",
    transform: "matrix(0 -1 1 0 -134.435 551.465)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m198.713 334.587h84.864v16.728h-84.864z",
    fill: "#5a5f64",
    transform: "matrix(0 -1 1 0 -101.806 584.095)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#373c41"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m231.342 334.587h84.864v16.728h-84.864z",
    transform: "matrix(0 -1 1 0 -69.176 616.724)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m263.972 334.587h84.864v16.728h-84.864z",
    transform: "matrix(0 -1 1 0 -36.547 649.354)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m296.601 334.587h84.864v16.728h-84.864z",
    transform: "matrix(0 -1 1 0 -3.917 681.983)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m133.454 334.587h84.864v16.728h-84.864z",
    fill: "#5a5f64",
    transform: "matrix(0 -1 1 0 -167.065 518.836)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m187.299 224.312h42.432v16.728h-42.432z",
    fill: "#5a5f64",
    transform: "matrix(0 -1 1 0 -24.16 441.191)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m219.929 224.312h42.432v16.728h-42.432z",
    fill: "#5a5f64",
    transform: "matrix(0 -1 1 0 8.469 473.82)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#373c41"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m252.558 224.312h42.432v16.728h-42.432z",
    transform: "matrix(0 -1 1 0 41.099 506.45)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m285.188 224.312h42.432v16.728h-42.432z",
    transform: "matrix(0 -1 1 0 73.728 539.079)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m255.483 186.277h95.696v16.728h-95.696z",
    fill: "#c7d1db"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255.483 265.21h116.25v16.728h-116.25z",
    fill: "#c7d1db"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m332.207 281.938h-153.448l76.724-42.901z",
    fill: "#c7d1db"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m332.207 281.938h-76.724v-42.901z",
    fill: "#a1aab7"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapitol);
export default __webpack_public_path__ + "static/media/capitol.cddb04dc6e011ff8345e8fceb1cea0b6.svg";
export { ForwardRef as ReactComponent };